/* Cart 01: native CartForm owns markup/counters; successful adds use ajaxProduct:added. */
(function () {
  'use strict';
  if (window.Cart01) return;
  var busy = false;
  var states = new WeakMap();
  var progressObservers = new WeakMap();
  var recommendationMarkup = new WeakMap();
  var recommendationLoads = new WeakSet();
  var recommendationPools = new WeakMap();
  var rootPath = function () { return window.Shopify && Shopify.routes ? Shopify.routes.root : '/'; };
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }
  function roots() { return Array.from(document.querySelectorAll('[data-cart-01]')); }
  function message(root, text) {
    var box = root.querySelector('[data-cart-01-error]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
    var status = root.querySelector('[data-cart-02-gift-dialog][open] [data-cart-02-wrap-status]');
    if (status) status.textContent = text || '';
  }
  function defaultError(root) { return root.dataset.errorMessage || 'Unable to update your cart. Please try again.'; }
  function addSections(data) {
    if (!data.has('sections') && document.querySelector('#CartDrawerForm[data-cart-view="cart-01-data"]')) {
      data.set('sections', 'cart-01-fragment');
      if (!data.has('sections_url')) data.set('sections_url', rootPath() + 'cart');
    }
    return data;
  }
  // 仅复用未变化的推荐栏；商品、库存和金额始终使用最新服务端内容。
  function renderItems(products, next) {
    var current = products.querySelector('.cart__items');
    var scroll = current && current.querySelector('.cart-01__scroll');
    var footer = current && current.querySelector('.cart-01__footer');
    var nextScroll = next.querySelector('.cart-01__scroll'), nextFooter = next.querySelector('.cart-01__footer');
    if (!scroll || !footer || !nextScroll || !nextFooter) return false;
    var oldRecommendations = current.querySelector('.cart-01__recommendations');
    var recommendations = next.querySelector('.cart-01__recommendations');
    var retain = oldRecommendations && recommendations && recommendationMarkup.get(oldRecommendations) === recommendations.outerHTML;
    Array.from(current.attributes).forEach(function (attribute) { if (!next.hasAttribute(attribute.name)) current.removeAttribute(attribute.name); });
    Array.from(next.attributes).forEach(function (attribute) { if (current.getAttribute(attribute.name) !== attribute.value) current.setAttribute(attribute.name, attribute.value); });
    // 推荐随商品滚动；空车仍在底部。两种容器均复用未变化的推荐节点。
    function reconcile(container, source) {
      var position = container.scrollTop;
      var cursor = container.firstElementChild;
      Array.from(source.children).forEach(function (child) {
        var node = retain && child === recommendations ? oldRecommendations : child;
        if (retain && node === oldRecommendations && node.parentNode === container) {
          while (cursor && cursor !== node) { var stale = cursor; cursor = cursor.nextElementSibling; stale.remove(); }
        }
        if (node === cursor) cursor = cursor.nextElementSibling;
        else container.insertBefore(node, cursor);
      });
      while (cursor) { var removed = cursor; cursor = cursor.nextElementSibling; removed.remove(); }
      container.scrollTop = position;
    }
    reconcile(scroll, nextScroll);
    reconcile(footer, nextFooter);
    return true;
  }
  async function request(path, data) {
    if (data) data = Object.assign({}, data, { sections: ['cart-01-fragment'], sections_url: rootPath() + 'cart' });
    var response = await fetch(rootPath() + path, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: data ? JSON.stringify(data) : undefined
    });
    var result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Unable to update cart.');
    return result;
  }
  function lock(value) {
    busy = value;
    roots().forEach(function (root) {
      root.setAttribute('aria-busy', String(value));
      var checkout = root.querySelector('.cart-01__checkout');
      if (checkout) checkout.inert = value || root.hasAttribute('data-service-sync-error');
      root.querySelectorAll('button,input,textarea,select').forEach(function (control) {
        if (control.classList.contains('js-drawer-close') || control.matches('[data-cart-01-discounts],[data-cart-02-wrap-close]')) return;
        if (value) {
          if (!control.hasAttribute('data-cart-01-disabled')) control.setAttribute('data-cart-01-disabled', String(control.disabled));
          control.disabled = true;
        } else if (control.hasAttribute('data-cart-01-disabled')) {
          control.disabled = control.getAttribute('data-cart-01-disabled') === 'true';
          control.removeAttribute('data-cart-01-disabled');
        }
      });
      root.querySelectorAll('.cart-01__quantity').forEach(function (q) { if (!value) q.classList.remove('is-loading'); });
      var state = states.get(root);
      if (!value && state && state.focusControl) {
        var focus = state.focusControl;
        if (focus.isConnected && !root.inert) {
          if (focus.disabled) focus = focus.closest('.cart-01__quantity')?.querySelector('input');
          if (focus) focus.focus({ preventScroll: true });
        }
        state.focusControl = null;
      }
    });
  }
  async function run(root, operation) {
    if (busy) return;
    message(root, '');
    lock(true);
    try { await operation(); }
    catch (error) { message(root, error.message || defaultError(root)); }
    finally { lock(false); roots().forEach(function (r) { var d = r.querySelector('[data-cart-02-gift-dialog][open]'); if (d) updateGiftDialog(d, false); }); }
  }
  function waitForRender(trigger) {
    return new Promise(function (resolve, reject) {
      var timer;
      function cleanup() { clearTimeout(timer); document.removeEventListener('cart:rendered', done); document.removeEventListener('cart-01:render-error', fail); }
      function done() { cleanup(); resolve(); }
      function fail() { cleanup(); reject(new Error('Cart updated, but the display could not refresh. Reload before trying again.')); }
      document.addEventListener('cart:rendered', done);
      document.addEventListener('cart-01:render-error', fail);
      timer = setTimeout(fail, 15000);
      trigger();
    });
  }
  function isProtection(item) { return item.properties && item.properties._cart_01_protection === 'true'; }
  function isWrap(item) { return !isProtection(item) && item.properties && (item.properties._cart_02_wrap === 'true' || item.properties._cart_gift_wrap === 'true'); }
  function parentCount(cart, variant) {
    return cart.items.reduce(function (count, item) {
      return count + (!isProtection(item) && !isWrap(item) && !(item.properties && item.properties._reward_gift === 'true') && String(item.variant_id) === String(variant) ? item.quantity : 0);
    }, 0);
  }
  function protectionChoice(count) {
    var select = document.querySelector('[data-cart-02-protection-variants]');
    if (!select) return null; // 旧片段仍沿用按件数量，完整刷新后切换到规格计费。
    var choices = Array.from(select.options).filter(function (option) { return !option.disabled && Number(option.dataset.count) === count; });
    if (choices.length !== 1) throw new Error('Protection is unavailable for this quantity. Remove protection or adjust the item quantity.');
    return { id: Number(choices[0].value), quantity: 1 };
  }
  async function replaceProtection(cart, item, choice) {
    var result = await request('cart/add.js', { items: [{ id: choice.id, quantity: 1, properties: item.properties }] });
    var added = result.items[0];
    try {
      cart = await request('cart.js');
      added = cart.items.find(function (line) { return isProtection(line) && line.variant_id === choice.id && String(line.properties._cart_01_parent) === String(item.properties._cart_01_parent); }) || added;
      var updates = {};
      cart.items.filter(function (line) { return isProtection(line) && String(line.properties._cart_01_parent) === String(item.properties._cart_01_parent); }).forEach(function (line) {
        updates[line.key] = line.variant_id === choice.id ? 1 : 0;
      });
      return await request('cart/update.js', { updates: updates });
    } catch (error) {
      if (added) { try { await request('cart/change.js', { id: added.key, quantity: 0 }); } catch (rollbackError) { serviceError(rollbackError); } }
      throw error;
    }
  }
  // Only already opted-in services follow their parent's quantity. Never enroll a new parent here.
  async function pruneProtection(cart) {
    var limit = cart.items.length * 2 + 2;
    while (limit-- > 0) {
      var seen = new Set(), mismatch = null, replacement = null;
      cart.items.forEach(function (item) {
        if (!isProtection(item)) return;
        var parent = String(item.properties._cart_01_parent);
        var expected = seen.has(parent) ? 0 : parentCount(cart, parent);
        seen.add(parent);
        var choice = expected ? protectionChoice(expected) : null;
        if (!mismatch && !replacement && choice && item.variant_id !== choice.id) replacement = { item: item, choice: choice };
        if (choice) expected = 1;
        if (!mismatch && !replacement && item.quantity !== expected) mismatch = { id: item.key, quantity: expected };
      });
      // Gift fees must not survive after the last ordinary product is removed.
      if (!mismatch && !cart.items.some(function (item) { return !isProtection(item) && !isWrap(item) && !(item.properties && item.properties._reward_gift === 'true'); })) {
        var wrap = cart.items.find(isWrap);
        if (wrap) mismatch = { id: wrap.key, quantity: 0 };
      }
      if (replacement) cart = await replaceProtection(cart, replacement.item, replacement.choice);
      else if (mismatch) cart = await request('cart/change.js', mismatch);
      else return cart;
    }
    throw new Error('Protection could not match the product quantity. Reload the cart before checkout.');
  }
  async function refreshCart(cart) {
    emit('cart:updated', { cart: cart });
    await waitForRender(function () { emit('cart:build', { cart: cart, sections: cart.sections }); });
  }
  function serviceError(error) {
    roots().forEach(function (root) {
      if (error) root.setAttribute('data-service-sync-error', '');
      else root.removeAttribute('data-service-sync-error');
      var checkout = root.querySelector('.cart-01__checkout');
      if (checkout) checkout.inert = busy || Boolean(error);
    });
  }
  async function quantityChanged(cartForm, event) {
    var key = event.detail[0], quantity = Number(event.detail[1]), wrapper = event.detail[2];
    if (!wrapper || !wrapper.closest('[data-cart-01]')) return;
    var root = wrapper.closest('[data-cart-01]');
    var input = wrapper.querySelector('input');
    var previous = Number(wrapper.dataset.originalQuantity);
    input.value = previous; // Keep confirmed quantity until the server returns new markup.
    if (busy || !Number.isInteger(quantity) || quantity < 0 || quantity === previous) return;
    if (input.hasAttribute('max') && quantity > Number(input.max)) {
      message(root, 'The available quantity is ' + input.max + '.');
      return;
    }
    wrapper.classList.add('is-loading');
    await run(root, async function () {
      var cart = await request('cart/change.js', { id: key, quantity: quantity });
      var cleanupError;
      try { cart = await pruneProtection(cart); }
      catch (error) { cleanupError = error; }
      serviceError(cleanupError);
      emit('cart:updated', { cart: cart });
      await waitForRender(function () { emit('cart:build', { cart: cart, sections: cart.sections }); });
      // A confirmed quantity change must still render if service cleanup fails.
      if (cleanupError) throw cleanupError;
    });
  }
  function closeMenus(except, focus) {
    document.querySelectorAll('[data-cart-01-variants][aria-expanded=true]').forEach(function (trigger) {
      if (trigger === except) return;
      trigger.setAttribute('aria-expanded', 'false');
      if (trigger.nextElementSibling.hidePopover && trigger.nextElementSibling.hasAttribute('popover')) trigger.nextElementSibling.hidePopover();
      trigger.nextElementSibling.hidden = true;
      if (focus) trigger.focus({ preventScroll: true });
    });
  }
  function openMenu(trigger, focus) {
    closeMenus(trigger);
    var menu = trigger.nextElementSibling;
    trigger.setAttribute('aria-expanded', 'true'); menu.hidden = false;
    if (menu.showPopover && menu.hasAttribute('popover')) { menu.showPopover(); positionPopup(trigger, menu); }
    if (focus) (menu.querySelector('[aria-selected=true]:not(:disabled)') || menu.querySelector('button:not(:disabled)')).focus({ preventScroll: true });
  }
  function selectVariant(option) {
    var card = option.closest('[data-cart-01-card]');
    var picker = option.closest('.cart-01__variant-picker');
    var trigger = picker.querySelector('[data-cart-01-variants]');
    picker.querySelectorAll('[role=option]').forEach(function (entry) { entry.setAttribute('aria-selected', String(entry === option)); });
    trigger.firstElementChild.textContent = option.dataset.variantTitle;
    card.querySelector('.cart-01__recommendation-price').innerHTML = option.dataset.variantPrice;
    var image = card.querySelector('.cart-01__recommendation-image img');
    if (image && option.dataset.variantImage) { image.removeAttribute('srcset'); image.src = option.dataset.variantImage; }
    var button = card.querySelector('[data-cart-01-add]');
    button.dataset.variantId = option.dataset.variantId; button.disabled = option.disabled;
    closeMenus(null, true);
  }
  function positionPopup(trigger, panel) {
    var root = trigger.closest('[data-cart-01]');
    var bounds = root ? root.getBoundingClientRect() : { left: 0, right: window.innerWidth, top: 0, bottom: window.innerHeight };
    var left = Math.max(0, bounds.left) + 8, right = Math.min(window.innerWidth, bounds.right) - 8;
    var top = Math.max(0, bounds.top) + 8, bottom = Math.min(window.innerHeight, bounds.bottom) - 8;
    panel.style.maxWidth = Math.max(0, right - left) + 'px';
    panel.style.maxHeight = Math.max(0, bottom - top) + 'px';
    panel.style.overflowY = 'auto';
    var anchor = trigger.getBoundingClientRect(), box = panel.getBoundingClientRect();
    panel.style.left = Math.max(left, Math.min(anchor.left, right - box.width)) + 'px';
    panel.style.top = Math.max(top, Math.min(bottom - box.height, anchor.bottom + box.height + 6 <= bottom ? anchor.bottom + 6 : anchor.top - box.height - 6)) + 'px';
  }
  function closeHelp(focus) {
    document.querySelectorAll('[data-cart-02-help][aria-expanded=true]').forEach(function (trigger) {
      var panel = trigger.closest('.cart-02__protection').querySelector('[data-cart-02-help-panel]');
      if (panel.hidePopover) panel.hidePopover();
      panel.hidden = true; trigger.setAttribute('aria-expanded', 'false');
      if (focus) trigger.focus({ preventScroll: true });
    });
  }
  document.addEventListener('scroll', function (event) {
    if (event.target.matches && event.target.matches('.cart-01__scroll,.cart-01__recommendation-track')) { closeHelp(); closeMenus(); }
  }, true);
  window.addEventListener('resize', function () { closeHelp(); closeMenus(); });
  function updateDots(section, index) {
    var cards = section.querySelectorAll('[data-cart-01-card]'), nav = section.querySelector('.cart-01__dots');
    while (nav.children.length > cards.length) nav.lastElementChild.remove();
    nav.hidden = cards.length <= 1;
    section.hidden = cards.length === 0 || (section.hasAttribute('data-cart-01-legacy-recommendations') && section.dataset.recommendationReady !== 'true');
    section.querySelectorAll('[data-cart-01-dot]').forEach(function (dot, i) { dot.setAttribute('aria-current', String(i === index)); });
    cards.forEach(function (card, i) { card.inert = i !== index; });
  }
  function showCard(section, index, immediate) {
    closeMenus();
    var cards = section.querySelectorAll('[data-cart-01-card]');
    index = Math.max(0, Math.min(index, cards.length - 1));
    updateDots(section, index);
    if (immediate || !cards.length) return;
    var behavior = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    if (window.UpsellRecommendations && typeof window.UpsellRecommendations.scrollToProduct === 'function') window.UpsellRecommendations.scrollToProduct(index, cards, behavior);
    else if (cards[index].scrollIntoView) cards[index].scrollIntoView({ behavior: behavior, block: 'nearest', inline: 'start' });
  }
  function hydrateRecommendations(section) {
    if (!section.hasAttribute('data-cart-01-legacy-recommendations') || recommendationLoads.has(section) || !window.UpsellRecommendations?.productsForCart) return;
    recommendationLoads.add(section);
    var ids = JSON.parse(section.dataset.cartProductIds || '[]').map(Number);
    var root = section.closest('[data-cart-01]');
    var pool = recommendationPools.get(root);
    // 当前页面固定首批推荐；加购后仅过滤已购商品，片段刷新不从候选集合补位。
    if (!pool) {
      pool = window.UpsellRecommendations.productsForCart(ids).catch(function (error) {
        if (recommendationPools.get(root) === pool) recommendationPools.delete(root);
        throw error;
      });
      recommendationPools.set(root, pool);
    }
    pool.then(function (candidates) {
      if (!section.isConnected) return;
      var products = candidates.filter(function (product) { return product.available && ids.indexOf(Number(product.id)) === -1; });
      var template = section.querySelector('[data-cart-01-recommendation-template]');
      var track = section.querySelector('.cart-01__recommendation-track');
      var nav = section.querySelector('.cart-01__dots');
      var cards = products.map(function (product) {
        var variant = product.variants.find(function (v) { return v.available; });
        var card = template.content.firstElementChild.cloneNode(true);
        card.dataset.productId = product.id;
        var title = card.querySelector('.cart-01__title'), link = card.querySelector('.cart-01__recommendation-image');
        title.textContent = product.title; title.title = product.title; title.href = product.url;
        link.href = product.url; link.setAttribute('aria-label', product.title);
        function picture(v) {
          var img = v.featured_image || (product.images || []).find(function (image) { return image.id === v.image_id; }) || product.featured_image;
          return typeof img === 'string' ? img : img?.src || '';
        }
        function money(price) { return theme.Currency.formatMoney(price, theme.settings.moneyFormat); }
        var image = link.querySelector('img'); image.alt = product.title;
        if (picture(variant)) image.src = picture(variant); else image.remove();
        var price = card.querySelector('.cart-01__recommendation-price'); price.innerHTML = money(variant.price);
        var add = card.querySelector('[data-cart-01-add]'); add.dataset.variantId = variant.id; add.dataset.phContentName = product.title;
        var picker = card.querySelector('.cart-01__variant-picker'), single = card.querySelector('.cart-01__single-variant');
        if (product.variants.length > 1) {
          single.remove();
          var trigger = picker.querySelector('button'), menu = picker.querySelector('[role=listbox]');
          trigger.setAttribute('aria-label', product.title); trigger.firstElementChild.textContent = variant.title;
          menu.setAttribute('aria-label', product.title);
          product.variants.forEach(function (v) {
            var option = document.createElement('button'); option.type = 'button'; option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', String(v.id === variant.id)); option.disabled = !v.available; option.textContent = v.title;
            option.dataset.variantId = v.id; option.dataset.variantPrice = money(v.price); option.dataset.variantTitle = v.title; option.dataset.variantImage = picture(v);
            menu.append(option);
          });
        } else { picker.remove(); if (variant.title === 'Default Title') single.remove(); else single.textContent = variant.title; }
        return card;
      });
      track.replaceChildren.apply(track, cards); nav.replaceChildren();
      cards.forEach(function (_, i) {
        var dot = document.createElement('button'); dot.type = 'button'; dot.setAttribute('data-cart-01-dot', String(i)); dot.setAttribute('aria-label', String(i + 1)); nav.append(dot);
      });
      section.dataset.recommendationReady = 'true';
      showCard(section, 0, true);
    }).catch(function () { section.hidden = true; recommendationLoads.delete(section); }); // 与旧版一致：接口失败隐藏推荐，下一次刷新可重试。
  }
  var swipe, suppressedTrack;
  document.addEventListener('pointerdown', function (event) {
    suppressedTrack = null;
    // 触屏交给浏览器原生滚动，避免按钮起滑被过滤或与 pointercancel 抢夺手势。
    if (event.pointerType === 'touch') return;
    var track = event.target.closest('.cart-01__recommendation-track');
    if (!track || busy || event.isPrimary === false || event.button !== 0 || event.target.closest('button,input,select,textarea,[role=listbox]')) return;
    swipe = { track: track, id: event.pointerId, x: event.clientX, y: event.clientY, dragging: false };
  });
  document.addEventListener('pointermove', function (event) {
    if (!swipe || event.pointerId !== swipe.id) return;
    var dx = event.clientX - swipe.x, dy = event.clientY - swipe.y;
    if (!swipe.dragging) {
      if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { swipe = null; return; }
      if (Math.abs(dx) < 10 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
      swipe.dragging = true;
      swipe.track.classList.add('is-dragging');
      swipe.track.setPointerCapture(event.pointerId);
    }
    if (event.cancelable) event.preventDefault();
  }, { passive: false });
  function finishSwipe(event) {
    if (!swipe || event.pointerId !== swipe.id) return;
    var current = swipe; swipe = null;
    current.track.classList.remove('is-dragging');
    if (current.track.hasPointerCapture(event.pointerId)) current.track.releasePointerCapture(event.pointerId);
    if (!current.dragging) return;
    suppressedTrack = current.track;
    var dx = event.clientX - current.x;
    if (event.type !== 'pointerup' || Math.abs(dx) < 36 || busy || !current.track.isConnected) return;
    var section = current.track.closest('.cart-01__recommendations');
    var dot = section.querySelector('[data-cart-01-dot][aria-current=true]');
    showCard(section, Number(dot.getAttribute('data-cart-01-dot')) + (dx < 0 ? 1 : -1));
  }
  document.addEventListener('pointerup', finishSwipe);
  document.addEventListener('pointercancel', finishSwipe);
  document.addEventListener('dragstart', function (event) { if (event.target.closest('.cart-01__recommendation-track')) event.preventDefault(); });
  document.addEventListener('click', function (event) {
    if (suppressedTrack && suppressedTrack.contains(event.target)) {
      suppressedTrack = null; event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  function saveState() {
    roots().forEach(function (root) {
      var active = document.activeElement;
      var item = active && active.closest('[data-key]');
      var summary = root.querySelector('[data-cart-01-discounts]');
      var state = states.get(root) || {};
      state.scroll = root.querySelector('.cart-01__scroll').scrollTop;
      state.discountOpen = summary && summary.getAttribute('aria-expanded') === 'true';
      if (item && root.contains(item)) state.focus = { variant: item.dataset.variantId, index: Array.from(item.parentNode.children).indexOf(item), plus: active.classList.contains('js-qty__adjust--plus'), input: active.tagName === 'INPUT' };
      states.set(root, state);
    });
  }
  function initialize() {
    roots().forEach(function (root) {
      var count = root.querySelector('[data-cart-02-product-count]');
      var items = root.querySelector('[data-product-count]');
      if (count && items) count.textContent = items.dataset.productCount;
      var oldObserver = progressObservers.get(root);
      if (oldObserver) oldObserver.disconnect();
      var progress = root.querySelector('[data-reward-progress]');
      if (progress) {
        var bar = progress.closest('[data-cart-reward-bar]');
        function remapProgress() {
          var three = bar.dataset.freeGiftEnable === 'true';
          var first = three ? 16.6667 : 25, last = three ? 83.3333 : 75;
          var width = Math.max(0, Math.min(100, (parseFloat(progress.style.width || '0') - first) / (last - first) * 100)) + '%';
          if (progress.style.getPropertyValue('--c01-progress') !== width) progress.style.setProperty('--c01-progress', width);
        }
        var observer = new MutationObserver(remapProgress);
        observer.observe(progress, { attributes: true, attributeFilter: ['style'] });
        progressObservers.set(root, observer);
        remapProgress();
      }
      root.querySelectorAll('.cart-01__recommendations').forEach(function (section) {
        hydrateRecommendations(section);
        if (recommendationMarkup.has(section)) return;
        recommendationMarkup.set(section, section.outerHTML);
        showCard(section, 0, true);
        var track = section.querySelector('.cart-01__recommendation-track');
        track.addEventListener('scroll', function () {
          var cards = Array.from(track.querySelectorAll('[data-cart-01-card]'));
          var index = cards.reduce(function (nearest, card, i) { return Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[nearest].offsetLeft - track.scrollLeft) ? i : nearest; }, 0);
          updateDots(section, index);
        }, { passive: true });
      });
      var state = states.get(root);
      if (state) {
        var summary = root.querySelector('[data-cart-01-discounts]');
        if (summary && state.discountOpen && !summary.disabled) { summary.setAttribute('aria-expanded', 'true'); summary.nextElementSibling.inert = false; }
        root.querySelector('.cart-01__scroll').scrollTop = state.scroll || 0;
        if (state.focus && !root.inert) {
          var items = Array.from(root.querySelectorAll('.cart-01__item'));
          var item = items.find(function (entry) { return entry.dataset.variantId === state.focus.variant; }) || items[Math.min(state.focus.index, items.length - 1)];
          var control = item && item.querySelector(state.focus.input ? 'input.js-qty__num' : state.focus.plus ? '.js-qty__adjust--plus' : '.js-qty__adjust--minus');
          // Focus restoration follows unlocking; stale controls never receive focus.
          if (control) { state.focusControl = control; }
          state.focus = null;
        }
      }
      if (busy) lock(true);
    });
  }
  document.addEventListener('click', function (event) {
    var root = event.target.closest('[data-cart-01]');
    var picker = event.target.closest('.cart-01__variant-picker');
    if (!picker) closeMenus();
    if (!root) return;
    // 动态片段中的继续购物复用稳定的原生关闭按钮，保留页面位置与焦点恢复。
    var continueShopping = event.target.closest('[data-cart-01-continue]');
    if (continueShopping && root.id === 'CartDrawer') {
      var closeButton = root.querySelector('.cart-01__header .js-drawer-close');
      if (closeButton) { event.preventDefault(); closeButton.click(); return; }
    }
    var discount = event.target.closest('[data-cart-01-discounts]');
    if (discount && !discount.disabled) {
      var open = discount.getAttribute('aria-expanded') !== 'true';
      discount.setAttribute('aria-expanded', String(open)); discount.nextElementSibling.inert = !open; return;
    }
    var trigger = event.target.closest('[data-cart-01-variants]');
    if (trigger) { if (trigger.getAttribute('aria-expanded') === 'true') closeMenus(); else openMenu(trigger, false); return; }
    var option = event.target.closest('[role=option]');
    if (option && !option.disabled) { selectVariant(option); return; }
    var dot = event.target.closest('[data-cart-01-dot]');
    if (dot) { showCard(dot.closest('.cart-01__recommendations'), Number(dot.getAttribute('data-cart-01-dot'))); return; }
    var add = event.target.closest('[data-cart-01-add]');
    if (add && !add.disabled) run(root, async function () {
      var product;
      try { product = await request('cart/add.js', { id: Number(add.dataset.variantId), quantity: 1 }); }
      catch (error) { emit('ajaxProduct:error', { errorMessage: error.message, addToCartBtn: add, source: 'upsell_recommendations' }); throw error; }
      var section = add.closest('.cart-01__recommendations'), card = add.closest('[data-cart-01-card]');
      if (section && card) { card.remove(); showCard(section, 0, true); section.querySelector('.cart-01__recommendation-track').scrollLeft = 0; }
      await waitForRender(function () {
        emit('ajaxProduct:added', { product: product, addToCartBtn: add, quantity: 1, source: 'upsell_recommendations', sections: product.sections });
        if (document.body.classList.contains('template-cart')) emit('cart:build', { sections: product.sections });
      });
    });
  });
  function giftDialog(root) { return root.querySelector('[data-cart-02-gift-dialog]'); }
  function giftChoice(dialog) {
    var separate = dialog.querySelector('[data-cart-02-wrap-mode]:checked').value === 'separate';
    var count = separate ? Number(dialog.querySelector('[data-cart-02-box-count]').value) : 1;
    var choices = Array.from(dialog.querySelectorAll('[data-cart-02-wrap-variants] option')).filter(function (option) { return Number(option.dataset.boxes) === count && !option.disabled; });
    return { separate: separate, count: count, option: choices.length === 1 ? choices[0] : null };
  }
  function updateGiftDialog(dialog, changed) {
    var choice = giftChoice(dialog);
    var hint = dialog.querySelector('[data-cart-02-wrap-hint]');
    if (hint) hint.textContent = choice.separate ? hint.dataset.separate : hint.dataset.together;
    var noteTitle = dialog.querySelector('[data-cart-02-note-title]');
    var note = dialog.querySelector('[data-cart-02-wrap-note]');
    if (noteTitle) noteTitle.textContent = choice.separate ? noteTitle.dataset.separate : noteTitle.dataset.together;
    var notePlaceholder = choice.separate ? note.dataset.separatePlaceholder : note.dataset.togetherPlaceholder;
    if (notePlaceholder !== undefined) note.placeholder = notePlaceholder;
    dialog.querySelector('[data-cart-02-boxes]').hidden = !choice.separate;
    dialog.querySelectorAll('[data-cart-02-wrap-price]').forEach(function (price) { price.textContent = choice.option ? choice.option.dataset.price : '—'; });
    dialog.querySelector('[data-cart-02-box-step="-1"]').disabled = busy || choice.count <= 1;
    dialog.querySelector('[data-cart-02-box-step="1"]').disabled = busy || choice.count >= 30;
    var save = dialog.querySelector('[data-cart-02-wrap-save]');
    save.disabled = busy || !choice.option || !Number.isInteger(choice.count) || choice.count < 1 || choice.count > 30;
    if (changed) {
      save.textContent = save.dataset.label;
      dialog.querySelector('[data-cart-02-wrap-status]').textContent = choice.option ? '' : dialog.dataset.unavailable;
    }
    dialog.querySelector('[data-cart-02-note-count]').textContent = note.value.length + ' / 200';
  }
  function prepareGift(root) {
    var dialog = giftDialog(root), entry = root.querySelector('[data-cart-02-gift-entry]');
    if (!dialog || !entry) return;
    dialog.querySelector('[data-cart-02-box-count]').value = Math.max(1, Math.min(30, Number(entry.dataset.boxes) || 1));
    dialog.querySelector('[data-cart-02-wrap-note]').value = (entry.dataset.note || '').slice(0, 200);
    dialog.querySelector('[data-cart-02-wrap-all]').checked = entry.dataset.packaging !== 'Separate boxes' && entry.dataset.wrapAll !== 'No';
    dialog.querySelectorAll('[data-cart-02-wrap-mode]').forEach(function (mode) { mode.checked = mode.value === (entry.dataset.packaging === 'Separate boxes' ? 'separate' : 'together'); });
    updateGiftDialog(dialog, true);
    return dialog;
  }
  function openGift(root) {
    if (busy) return;
    var dialog = prepareGift(root);
    if (!dialog) return;
    closeMenus(); closeHelp();
    dialog.showModal();
  }
  function stepService(root, button) {
    if (busy) return;
    var control = button.closest('[data-cart-02-service-quantity]');
    var step = Number(button.getAttribute('data-cart-02-service-step')), count = Number(control.querySelector('input').value) + step;
    if (control.getAttribute('data-cart-02-service-quantity') === 'wrap') {
      if (count <= 0) { run(root, function () { return removeWrap(root); }); return; }
      var dialog = prepareGift(root);
      if (!dialog || count > 30) return;
      dialog.querySelector('[data-cart-02-box-count]').value = count;
      if (count > 1) {
        dialog.querySelector('[data-cart-02-wrap-mode][value=separate]').checked = true;
        dialog.querySelector('[data-cart-02-wrap-all]').checked = false;
      }
      updateGiftDialog(dialog, true);
      run(root, function () { return saveGift(root, dialog, button, true); });
      return;
    }
    if (count <= 0) {
      run(root, function () { return toggleProtection(root, { dataset: { parentVariant: control.dataset.parentVariant, selected: 'true' } }); });
      return;
    }
    try { protectionChoice(count); } catch (error) { message(root, error.message); return; }
    // 保护覆盖件数与父商品同步；服务行自身 quantity 始终为 1，避免档位费用再次乘数量。
    var parents = Array.from(root.querySelectorAll('.cart-01__item:not([data-cart-02-service-row])')).filter(function (row) { return row.dataset.variantId === control.dataset.parentVariant; });
    var parent = step > 0 ? parents.find(function (row) { var input = row.querySelector('.js-qty__num'); return input && (!input.hasAttribute('max') || Number(input.value) < Number(input.max)); }) : parents[parents.length - 1];
    if (!parent) { message(root, 'The associated product cannot be increased.'); return; }
    var wrapper = parent.querySelector('.js-qty__wrapper'), input = wrapper && wrapper.querySelector('input');
    if (input) quantityChanged(null, { detail: [parent.dataset.key, Number(input.value) + step, wrapper] });
  }
  function closeGift(dialog, saved) {
    if (busy && !saved) return;
    dialog.close();
    var root = dialog.closest('[data-cart-01]');
    var trigger = root.querySelector('[data-cart-02-wrap-open],[data-cart-02-wrap-toggle]');
    if (busy) {
      var state = states.get(root) || {};
      state.focusControl = trigger; states.set(root, state);
    } else if (trigger && !root.inert) trigger.focus({ preventScroll: true });
  }
  async function removeWrap(root) {
    var cart = await request('cart.js'), updates = {};
    cart.items.filter(isWrap).forEach(function (item) { updates[item.key] = 0; });
    if (Object.keys(updates).length) cart = await request('cart/update.js', { updates: updates });
    await refreshCart(cart);
  }
  async function saveGift(root, dialog, button, keepOpen) {
    var choice = giftChoice(dialog);
    if (!choice.option) throw new Error(dialog.dataset.unavailable);
    var cart = await request('cart.js');
    var existing = cart.items.filter(isWrap);
    var same = existing.find(function (item) { return String(item.variant_id) === choice.option.value; });
    var properties = Object.assign({}, same ? same.properties : {}, {
      _cart_02_wrap: 'true', _cart_gift_wrap: 'true', _cart_02_boxes: String(choice.count),
      Packaging: choice.separate ? 'Separate boxes' : 'One gift box',
      'Wrap all items': dialog.querySelector('[data-cart-02-wrap-all]').checked ? 'Yes' : 'No',
      'Gift note': dialog.querySelector('[data-cart-02-wrap-note]').value.slice(0, 200)
    });
    var added, keep;
    try {
      if (same) {
        cart = await request('cart/change.js', { id: same.key, quantity: 1, properties: properties });
        keep = cart.items.find(function (item) { return isWrap(item) && String(item.variant_id) === choice.option.value && item.properties._cart_02_boxes === String(choice.count); });
      } else {
        var result = await request('cart/add.js', { items: [{ id: Number(choice.option.value), quantity: 1, properties: properties }] });
        added = result.items[0]; keep = added;
        // 首次包装的 add 响应已确认新行数量和完整界面；替换旧行才需重读折扣变化后的 key。
        cart = existing.length ? await request('cart.js') : result;
      }
      if (!keep) throw new Error('Gift wrap could not be confirmed. Reload before trying again.');
      if (keep.quantity !== 1) {
        cart = await request('cart/change.js', { id: keep.key, quantity: 1 });
        keep = cart.items.find(function (item) { return isWrap(item) && String(item.variant_id) === choice.option.value && item.properties._cart_02_boxes === String(choice.count); });
        if (!keep || keep.quantity !== 1) throw new Error('Gift wrap quantity could not be confirmed.');
      }
      var updates = {};
      cart.items.filter(isWrap).forEach(function (item) { if (item.key !== keep.key) updates[item.key] = 0; });
      if (Object.keys(updates).length) cart = await request('cart/update.js', { updates: updates });
    } catch (error) {
      // Remove a confirmed newly added line if replacing the old option failed.
      if (added) {
        try { await request('cart/change.js', { id: added.key, quantity: 0 }); }
        catch (rollbackError) { serviceError(rollbackError); }
      }
      if (!same) emit('ajaxProduct:error', { errorMessage: error.message, addToCartBtn: button, source: 'cart_gift_wrap' });
      try { await refreshCart(await request('cart.js')); } catch (refreshError) { /* Original failure remains visible. */ }
      throw error;
    }
    if (added) {
      await waitForRender(function () {
        var payload = { product: added, addToCartBtn: button, quantity: 1, source: 'cart_gift_wrap', sections: cart.sections };
        if (typeof cart.item_count === 'number') payload.cart = cart;
        emit('ajaxProduct:added', payload);
        if (document.body.classList.contains('template-cart')) emit('cart:build', payload);
      });
    } else await refreshCart(cart);
    if (!keepOpen) closeGift(dialog, true);
  }
  async function toggleProtection(root, control) {
    var cart = await request('cart.js'), parent = control.dataset.parentVariant;
    var services = cart.items.filter(function (item) { return isProtection(item) && String(item.properties._cart_01_parent) === parent; });
    if (control.dataset.selected === 'true') {
      var updates = {};
      services.forEach(function (item) { updates[item.key] = 0; });
      if (services.length) cart = await request('cart/update.js', { updates: updates });
      cart = await pruneProtection(cart);
      serviceError(false);
      await refreshCart(cart);
    } else {
      if (services.length) { await refreshCart(await pruneProtection(cart)); return; }
      var quantity = parentCount(cart, parent);
      if (!quantity) { await refreshCart(cart); return; }
      var choice = protectionChoice(quantity) || { id: Number(control.dataset.serviceVariant), quantity: quantity };
      var result;
      try { result = await request('cart/add.js', { items: [{ id: choice.id, quantity: choice.quantity, properties: { _cart_01_protection: 'true', _cart_01_parent: parent } }] }); }
      catch (error) { emit('ajaxProduct:error', { errorMessage: error.message, addToCartBtn: control, source: 'cart_01_protection' }); throw error; }
      var syncError;
      try { await pruneProtection(await request('cart.js')); }
      catch (error) { syncError = error; }
      serviceError(syncError);
      await waitForRender(function () {
        emit('ajaxProduct:added', { product: result.items[0], addToCartBtn: control, quantity: choice.quantity, source: 'cart_01_protection' });
        if (document.body.classList.contains('template-cart')) emit('cart:build');
      });
      if (syncError) throw syncError;
    }
  }
  document.addEventListener('click', function (event) {
    var help = event.target.closest('[data-cart-02-help]');
    if (help) {
      var open = help.getAttribute('aria-expanded') === 'true'; closeHelp(); closeMenus();
      if (!open) { var panel = help.closest('.cart-02__protection').querySelector('[data-cart-02-help-panel]'); panel.hidden = false; if (panel.showPopover) panel.showPopover(); help.setAttribute('aria-expanded', 'true'); positionPopup(help, panel); }
      return;
    }
    if (!event.target.closest('[data-cart-02-help-panel]')) closeHelp();
    var root = event.target.closest('[data-cart-01]');
    if (!root) return;
    var serviceStep = event.target.closest('[data-cart-02-service-step]');
    if (serviceStep && !serviceStep.disabled) { stepService(root, serviceStep); return; }
    if (event.target.closest('[data-cart-02-wrap-open]')) { openGift(root); return; }
    if (event.target.closest('[data-cart-02-wrap-remove]')) { run(root, function () { return removeWrap(root); }); return; }
    var dialog = event.target.closest('[data-cart-02-gift-dialog]');
    if (dialog) {
      if (event.target.closest('[data-cart-02-wrap-close]')) { closeGift(dialog); return; }
      var step = event.target.closest('[data-cart-02-box-step]');
      if (step && !busy) {
        var input = dialog.querySelector('[data-cart-02-box-count]');
        input.value = Math.max(1, Math.min(30, (Number(input.value) || 1) + Number(step.getAttribute('data-cart-02-box-step'))));
        updateGiftDialog(dialog, true); return;
      }
      var save = event.target.closest('[data-cart-02-wrap-save]');
      if (save && !save.disabled) { run(root, function () { return saveGift(root, dialog, save); }); return; }
      if (event.target === dialog) {
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeGift(dialog);
      }
    }
    var protection = event.target.closest('[data-cart-02-protection]');
    if (protection && !protection.disabled) { run(root, function () { return toggleProtection(root, protection); }); return; }
    var remove = event.target.closest('[data-cart-02-discount-remove]');
    if (remove && !remove.disabled) run(root, async function () {
      var cart = await request('cart.js');
      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      (cart.cart_level_discount_applications || []).concat(cart.items.flatMap(function (item) { return (item.line_level_discount_allocations || []).map(function (a) { return a.discount_application; }); })).forEach(function (d) { if (d.type === 'discount_code') codes.push(d.title); });
      codes = Array.from(new Set(codes)).filter(function (code) { return code.toLowerCase() !== remove.getAttribute('data-cart-02-discount-remove').toLowerCase(); });
      await refreshCart(await request('cart/update.js', { discount: codes.join(',') }));
    });
  });
  document.addEventListener('change', function (event) {
    var control = event.target.closest('[data-cart-02-wrap-toggle]');
    if (control) {
      var selected = control.checked, root = control.closest('[data-cart-01]');
      control.checked = !selected;
      if (selected) {
        openGift(root);
        var gift = giftDialog(root);
        if (gift && gift.open) run(root, function () { return saveGift(root, gift, control, true); });
      } else run(root, function () { return removeWrap(root); });
      return;
    }
    var dialog = event.target.closest('[data-cart-02-gift-dialog]');
    if (dialog && !busy) {
      if (event.target.matches('[data-cart-02-wrap-mode]')) dialog.querySelector('[data-cart-02-wrap-all]').checked = event.target.value === 'together';
      if (event.target.matches('[data-cart-02-wrap-all]') && event.target.checked) dialog.querySelector('[data-cart-02-wrap-mode][value=together]').checked = true;
      updateGiftDialog(dialog, true);
    }
  });
  document.addEventListener('input', function (event) {
    var dialog = event.target.closest('[data-cart-02-gift-dialog]');
    if (dialog && !busy) updateGiftDialog(dialog, true);
  });
  document.addEventListener('keydown', function (event) {
    var dialog = event.target.closest('[data-cart-02-gift-dialog][open]');
    if (dialog) {
      if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); closeGift(dialog); }
      if (event.key === 'Tab') event.stopPropagation(); // Native modal dialog owns the nested focus trap.
      return;
    }
    if (event.key === 'Escape') {
      if (document.querySelector('[data-cart-02-help][aria-expanded=true]')) { event.preventDefault(); event.stopImmediatePropagation(); closeHelp(true); return; }
      var opened = document.querySelector('[data-cart-01-variants][aria-expanded=true]');
      if (opened) { event.preventDefault(); event.stopImmediatePropagation(); closeMenus(null, true); }
      return;
    }
    var picker = event.target.closest('.cart-01__variant-picker');
    if (!picker) return;
    var trigger = picker.querySelector('[data-cart-01-variants]');
    if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
      event.preventDefault();
      if (trigger.getAttribute('aria-expanded') !== 'true') { openMenu(trigger, true); return; }
      var options = Array.from(picker.querySelectorAll('[role=option]:not(:disabled)'));
      var index = options.indexOf(document.activeElement);
      index = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      if (options[index]) options[index].focus();
    } else if (event.key === 'Tab') closeMenus();
  }, true);
  document.addEventListener('cancel', function (event) {
    if (event.target.matches('[data-cart-02-gift-dialog]')) { event.preventDefault(); closeGift(event.target); }
  }, true);
  document.addEventListener('submit', function (event) { if (event.target.closest('[data-cart-01]') && (busy || event.target.closest('[data-service-sync-error]'))) event.preventDefault(); }, true);
  document.addEventListener('cart-01:before-render', function () { closeHelp(); closeMenus(); saveState(); });
  document.addEventListener('cart:rendered', initialize);
  document.addEventListener('cart:rendered', function () {
    if (busy) return;
    var root = roots().find(function (r) { return r.querySelector('[data-cart-02-service]'); });
    if (!root) return;
    run(root, async function () {
      var cart = await request('cart.js');
      try { var synced = await pruneProtection(cart); serviceError(false); if (synced !== cart) await refreshCart(synced); }
      catch (error) { serviceError(error); throw error; }
    });
  });
  document.addEventListener('page:loaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('cart-01:render-error', function () { roots().forEach(function (root) { message(root, defaultError(root)); }); });
  window.Cart01 = { quantityChanged: quantityChanged, addSections: addSections, renderItems: renderItems };
  document.addEventListener('DOMContentLoaded', initialize);
  if (document.readyState !== 'loading') initialize();
})();
